<template>
    <div>
        <div class="card shadow-sm">
            <div class="card-body">
                <static-loading-indicator-icon
                    :loading="$store.getters.shouldLoadLocal"
                />
                <div v-if="!$store.getters.shouldLoadLocal">
                    <h3 class="card-title">
                        {{ $t("pages.subscription.start.questions.title") }}
                    </h3>
                    <hr/>
                    <div v-if="questions !== null">
                        <div
                            v-for="(question, i) in questions"
                            :key="i"
                            class="mt-4"
                        >
                            <h5
                                class="font-weight-lighter"
                                :class="{ 'text-danger': question.answer }"
                            >
                                {{ question.text }}
                            </h5>

                            <div class="form-check-inline">
                                <p v-if="question.answer" class="text-danger font-weight-bold">
                                    {{ $t('pages.subscription.start.questions.answer_yes') }}
                                </p>
                                <p v-else>
                                    {{ $t('pages.subscription.start.questions.answer_no') }}
                                </p>
                            </div>
                            <hr/>
                        </div>
                    </div>
                    <div v-else>
                        <p>
                            {{
                                $t("pages.admin.users.information.health.empty")
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminUsersRepository from "../../../../repositories/Admin/AdminUsersRepository";
import StaticLoadingIndicatorIcon from "../../../Includes/StaticLoadingIndicatorIcon";

export default {
    name: "UserHealthQuestion",
    components: {StaticLoadingIndicatorIcon},
    data: () => ({
        goal: null,
        questions: [
            {answer: null, text: ""},
            {answer: null, text: ""},
            {answer: null, text: ""},
            {answer: null, text: ""},
            {answer: null, text: ""},
            {answer: null, text: ""},
            {answer: null, text: ""}
        ]
    }),
    mounted() {
        this.questions[0].text = this.$t(
            "pages.subscription.start.questions.question_one"
        );
        this.questions[1].text = this.$t(
            "pages.subscription.start.questions.question_two"
        );
        this.questions[2].text = this.$t(
            "pages.subscription.start.questions.question_three"
        );
        this.questions[3].text = this.$t(
            "pages.subscription.start.questions.question_four"
        );
        this.questions[4].text = this.$t(
            "pages.subscription.start.questions.question_five"
        );
        this.questions[5].text = this.$t(
            "pages.subscription.start.questions.question_six"
        );
        this.questions[6].text = this.$t(
            "pages.subscription.start.questions.question_seven"
        );

        AdminUsersRepository.getUserHealthQuestions(
            this.$route.params.user
        ).then(res => {
            this.goal = res.data.goal;

            let answers = res.data.answers;
            if (answers) {
                answers.forEach((a, i) => (this.questions[i].answer = !!a));
            }
        });
    },
    computed: {},
    methods: {}
};
</script>

<style scoped></style>
